"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "stienta": {
    "80bf9738": [{
      "hkey": "77d1bed2",
      "slug": "sabbioni-zampine",
      "name": "Sabbioni-Zampine",
      "primary": true,
      "skipSearch": false
    }],
    "sabbioni": [{
      "hkey": "77d1bed2",
      "slug": "sabbioni-zampine",
      "name": "Sabbioni-Zampine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "stienta"
    }],
    "8612bfc8": [{
      "hkey": "77d1bed2",
      "slug": "sabbioni-zampine",
      "name": "Sabbioni-Zampine",
      "primary": true,
      "skipSearch": false
    }],
    "zampine": [{
      "hkey": "77d1bed2",
      "slug": "sabbioni-zampine",
      "name": "Sabbioni-Zampine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;